import MuiTooltip from '@mui/material/Tooltip';
import type { TooltipProps } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';
import { ReactNode } from 'react';

interface TooltipFunctionalProps {
  placement?: TooltipProps['placement'];
  title: string | ReactNode;
  children: React.ReactElement | React.ReactElement[] | string;
  open?: boolean;
}

interface TooltipVisualProps {
  resizing?: 'wrap' | 'fixedSmall' | 'fixedMedium' | 'fixedLarge';
}

export const Tooltip = (props: TooltipFunctionalProps & TooltipVisualProps) => (
  <ArrowTooltip {...props}>
    <div>{props.children}</div>
  </ArrowTooltip>
);

const ArrowTooltip = styled(
  ({ className, ...props }: TooltipProps & TooltipVisualProps) => (
    <MuiTooltip
      arrow
      {...props}
      classes={{ popper: className }}
      open={props.open}
    />
  ),
)((props) => {
  let width;
  if (props.resizing === 'fixedSmall') width = 150;
  if (props.resizing === 'fixedMedium') width = 300;
  if (props.resizing === 'fixedLarge') width = 500;

  return {
    [`& .${tooltipClasses.arrow}`]: {
      // color: colors.neutral800,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      padding: '12px',
      // backgroundColor: colors.neutral800,
      fontSize: 12,
      textAlign: 'center',
      width,
      maxWidth: width,
    },
  };
});
